module.exports = __webpack_public_path__ + "media/images/pages/ic-arrow-right-6cf001139a93a79a84bb83d51bba6cc7.png";